// Types of action for requesting export component as image
export const REQUEST_EXPORT_AS_IMAGE = 'REQUEST_EXPORT_AS_IMAGE';
export const REQUEST_EXPORT_AS_IMAGE_PENDING = 'REQUEST_EXPORT_AS_IMAGE_PENDING';
export const REQUEST_EXPORT_AS_IMAGE_SUCCESS = 'REQUEST_EXPORT_AS_IMAGE_SUCCESS';
export const REQUEST_EXPORT_AS_IMAGE_ERROR = 'REQUEST_EXPORT_AS_IMAGE_ERROR';